import React, { useMemo, useEffect } from "react";
import { MaterialReactTable } from "material-react-table";
import { Box } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import TitlePages from "../../../layout/TitlePages";
import Breadcrumbs from "../../../layout/Breadcrumbs";
import Expandible from "../../../layout/HelperDataTable/Expandible";
import { useSubRowsTableConfig } from "../../../constants";
import { dataArt632025 } from "../../../data/2025/Art632025";

const baseUrlPDF = "https://itetlax.org.mx/assets/pdf/transparencia/art63/";
const baseUrlExcel = "https://itetlax.org.mx/assets/excel/transparencia/art63/";

const ExcelLink = ({ baseUrl, urls }) => {
  return urls.map((url) => {
    const fullUrl = `${baseUrl}2025/${url}`;
    const displayText = url.substring(0, url.lastIndexOf("."));
    return (
      <tr className="table-secondary" key={fullUrl}>
        <td>{displayText}</td>
        <td>
          <a href={fullUrl} target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faFileExcel} className="btn btn-success" />
          </a>
        </td>
      </tr>
    );
  });
};

const PdfLink = ({ baseUrl, urls }) => {
  return urls.map((url) => {
    const fullUrl = `${baseUrl}2025/${url}`;
    const displayText = url.substring(0, url.lastIndexOf("."));
    return (
      <tr className="table-secondary" key={fullUrl}>
        <td>{displayText}</td>
        <td>
          <a href={fullUrl} target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faFilePdf} className="btn btn-danger" />
          </a>
        </td>
      </tr>
    );
  });
};

const Art632025 = () => {
  useEffect(() => {
    document.title = `Artículo 63 2025`;
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "fraccion",
        header: "Fracción",
        footer: "Fracción",
        size: 90,
        enableResizing: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "titulo",
        header: "Título",
        footer: "Título",
        size: 150,
        enableResizing: false,
      },
      {
        accessorKey: "cumplimiento",
        header: "Cumplimiento",
        footer: "Cumplimiento",
        size: 100,
        enableResizing: false,
        filterFn: "equals",
        filterSelectOptions: [
          { text: "Aplica", value: "Aplica" },
          { text: "No Aplica", value: "No Aplica" },
        ],
        filterVariant: "select",
      },
    ],
    []
  );

  const rootData = useMemo(() => dataArt632025.filter((r) => !r.managerId), []);

  const renderTransparencia = ({ row }) => {
    const { managerId, fraccion, ...rest } = row.original;
    const excels = Object.keys(rest)
      .filter((key) => key.startsWith("excel"))
      .map((key) => rest[key]);
    const pdfs = Object.keys(rest)
      .filter((key) => key.startsWith("pdf"))
      .map((key) => rest[key]);

    if (excels.length > 0 || pdfs.length > 0) {
      return (
        <Box id="Box">
          <div className="table-responsive">
            <table className="table table-hover table-sm table-bordered table align-middle w-25">
              <thead>
                <tr>
                  <td colSpan={2}>
                    <br />
                    <strong>Fracción {fraccion}</strong>
                    <br />
                    <br />
                  </td>
                </tr>
              </thead>
              <tbody>
                {excels.length > 0 && (
                  <ExcelLink baseUrl={baseUrlExcel} urls={excels} />
                )}
                {pdfs.length > 0 && (
                  <PdfLink baseUrl={baseUrlPDF} urls={pdfs} />
                )}
              </tbody>
            </table>
          </div>
        </Box>
      );
    }
    return null;
  };

  const table = useSubRowsTableConfig(rootData, columns, renderTransparencia, {
    getSubRows: (row) => dataArt632025.filter((r) => r.managerId === row.id),
  });

  return (
    <>
      <div className="margin-bottom-2">
        <Breadcrumbs
          path={[
            { label: "Transparencia", url: "/Transparencia" },
            { label: "Artículo 63 Obligaciones Comunes", url: "/Articulo63" },
            { label: `Artículo 63 2025` },
          ]}
        />
        <TitlePages
          title="Transparencia"
          subTitle="Artículo 63. (2025) Obligaciones Comunes"
        />
        <Expandible />
        <MaterialReactTable table={table} />
      </div>
    </>
  );
};

export default Art632025;